import { render } from "./SupplierPageList.vue?vue&type=template&id=f0cedd62&scoped=true"
import script from "./SupplierPageList.vue?vue&type=script&lang=ts"
export * from "./SupplierPageList.vue?vue&type=script&lang=ts"

import "./SupplierPageList.vue?vue&type=style&index=0&id=f0cedd62&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f0cedd62"

export default script